import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import media from 'src/styles/Media.styled';
import styled from 'styled-components';
export const CloseIconContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    order: 3;
    width: 5%;
    margin: 2px 6px 0 0;
    ${media.mediumDevice`
    margin: 2px 0 0 0;
    `}
    ${media.smalDevice`
    margin: 2px 1px 0 0;
    `}
    ${media.mobileDevice`
        order: 2;
        width: 0%;
    `}
`;
export const CloseIcon = styled(Icon)``;

export const HeaderContainer = styled.div`
    display: inherit;
    position: relative;
    justify-content: space-between;
`;

export const HeaderDetails = styled.div`
    display: inherit;
    justify-content: space-between;
    align-items: center;

    ${media.mobileDevice`
        // display: block ;
    `};
`;

export const HeaderSpan = styled.div`
    padding-left: 12px;
    font-family: 'AvenirNextWorld Italic';
    font-size: 18px;
    margin: 0px;
    color: #130e4a;
`;

export const FavoriteIconMobileContainer = styled.div`
    display: none;
    ${media.mobileDevice`
        background: #ffffff;
        box-shadow: 0px 0px 2px #00000029;
        border: 1px solid #ebebeb;
        border-radius: 6px;
        opacity: 1;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${({ marginRight }) => marginRight};
    `};
`;
export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 24px;
    height: 24px;
    display: block;
    cursor: pointer;
`;

export const AccountHeaderFont = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '18px' : '18px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#130E4A' : isDemi && '#130E4A'};
    margin: 0px;
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '18px' : '18px')};
    `}
`;

export const AccountSubHeaderFont = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '18px' : '13px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#130E4A'};
    margin: 2px;
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '18px' : '13px')};
    `}
`;

export const FavoriteIconContainer = styled.div`
    background: #ffffff;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 30px !important;
    height: 30px !important;
    display: flex;
    align-items: center;

    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
    position: absolute;
    right: 74px;
    ${media.mobileDevice`
     margin-right:35px;
     right: 5px;
    `};
`;
